import script from "./LoaderUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderUI.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderUI.vue?vue&type=style&index=0&id=46c07305&lang=scss"

const __exports__ = script;

export default __exports__